module.exports = __webpack_public_path__ + "img/bg-elder-square.c9fcb785.webp";